import React, { Component } from 'react';
import { func } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getCurrentConditions as getCurrentConditionsByFieldId,
  getCurrentConditionsByLocation,
} from '../actions/weatherForecastActions';
import { CurrentConditions } from '../components/CurrentConditions';
import { CurrentConditionsType, FieldType } from '../types';
import { createUnitOrNotApplicable } from '../utils/createUnitOrNotApplicable';

class CurrentConditionsContainer extends Component {
  componentDidMount() {
    const { getCurrentConditions: getCurrentConditionsProp, field } =
      this.props;
    getCurrentConditionsProp(field);
  }

  componentDidUpdate(prevProps) {
    const { field, getCurrentConditions: getCurrentConditionsProp } =
      this.props;

    if (prevProps.field.id !== field.id) {
      getCurrentConditionsProp(field);
    }
  }

  render() {
    const { currentConditions } = this.props;
    const {
      dewPoint,
      humidity,
      temperature,
      weatherCondition,
      windSpeed,
      windDirection,
    } = currentConditions;

    // TODO: Use reselect for the unitQty functions below
    return (
      <div>
        {Object.keys(currentConditions).length ? (
          <CurrentConditions
            {...{
              humidity: createUnitOrNotApplicable(humidity.q, 'percent')
                .forLocaleGroup('humidity')
                .toString(),
              weatherCondition,
              windDirection,
              dewPoint: createUnitOrNotApplicable(dewPoint.q, dewPoint.u)
                .forLocaleGroup('temperature')
                .toString(),
              temperature: createUnitOrNotApplicable(
                temperature.q,
                temperature.u
              )
                .forLocaleGroup('temperature')
                .toString(),
              windSpeed: createUnitOrNotApplicable(windSpeed.q, windSpeed.u)
                .forLocaleGroup('wind-speed')
                .toString(),
            }}
          />
        ) : null}
      </div>
    );
  }
}

CurrentConditionsContainer.propTypes = {
  currentConditions: CurrentConditionsType,
  field: FieldType,
  getCurrentConditions: func.isRequired,
};

function mapStateToProps(state) {
  return {
    field: state.field,
    currentConditions: state.weatherForecast.currentConditions,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  const { isMicrosoftWxFeatureAvailable } = ownProps;
  const getCurrentConditions = isMicrosoftWxFeatureAvailable
    ? getCurrentConditionsByLocation
    : getCurrentConditionsByFieldId;

  return bindActionCreators(
    {
      getCurrentConditions,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CurrentConditionsContainer);
